import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-loader flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      alt: "Logo",
      src: "/media/fit-media/logo-fitp.png",
      style: {"height":"13rem"}
    }, null, -1),
    _createElementVNode("div", { class: "d-flex align-items-center mt-5" }, [
      _createElementVNode("span", {
        class: "spinner-border text-primary",
        role: "status"
      }),
      _createElementVNode("span", { class: "text-gray-600 fs-6 fw-bold ms-5" }, "Loading...")
    ], -1)
  ]))]))
}